import type { ReactNode } from "react";

interface Props {
  isPending: boolean;
  isError: boolean;
  errorMessage: ReactNode;
  /** 一覧が0件のときだけ渡す。読み込み中・失敗のときは無視される */
  isEmpty?: boolean;
  emptyMessage?: ReactNode;
  /** 既定は素の一覧向け(text-sm)。中央寄せの余白が要る面はここで上書きする */
  className?: string;
  /** 空メッセージだけ別の余白にしたいとき(通知一覧など)。省略時は className を使う */
  emptyClassName?: string;
}

/**
 * 一覧の「読み込み中/取得失敗/空」の三点セット(→ CLAUDE.md の文言の型)を1箇所にまとめた表示。
 * 何も表示しないときは null を返すので、呼び出し側は一覧の直前にそのまま置ける。
 */
export default function QueryState({
  isPending,
  isError,
  errorMessage,
  isEmpty = false,
  emptyMessage,
  className = "text-sm",
  emptyClassName,
}: Props) {
  if (isPending) {
    return <p className={`${className} text-[var(--color-sub)]`}>読み込み中...</p>;
  }
  if (isError) {
    return (
      <p role="alert" className={`${className} text-[var(--color-plum)]`}>
        {errorMessage}
      </p>
    );
  }
  if (isEmpty && emptyMessage !== undefined) {
    return (
      <p className={`${emptyClassName ?? className} text-[var(--color-sub)]`}>{emptyMessage}</p>
    );
  }
  return null;
}
